import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var ApiIntegrations = Class.create({
	getApiKey: function(callback) {
		var url = "integrations/apikey";
		// #  Send to server object for processing
		var data = server.getData(url, null, true);
		// #  Listen to our data
		data
		.done(function(response){
			if(callback) {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	generateApiKey: function(callback) {
		var url = "integrations/apikey";
		// #  Send to server object for processing
		var data = server.getData(url, null, true, "POST");
		// #  Listen to our data
		data
		.done(function(response){
			if(callback) {
				modal.showInfo("API key was generated!", "success", "top", "center");
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	deleteApiKey: function(callback) {
		var url = "integrations/apikey";
		// #  Send to server object for processing
		var data = server.getData(url, null, true, "DELETE");
		// #  Listen to our data
		data
		.done(function(response){
			if(callback) {
				modal.showInfo("API key was deleted!", "success", "top", "center");
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
});

export let apiIntegrations = new ApiIntegrations();


// WEBPACK FOOTER //
// app/core/controllers/ApiIntegrations.js